import { render } from "./AdminTransactionHistory.vue?vue&type=template&id=807351ce&scoped=true"
import script from "./AdminTransactionHistory.vue?vue&type=script&lang=js"
export * from "./AdminTransactionHistory.vue?vue&type=script&lang=js"

import "./AdminTransactionHistory.vue?vue&type=style&index=0&id=807351ce&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807351ce"]])

export default __exports__